<template>
	<div>
		<el-card>
			<el-form :model="form" ref="form" label-position="left" :inline="true">
				<el-form-item label="提现日期:" style="margin-left:20px">
                    <div class="block">
                        <el-date-picker
                        v-model="form.time"
                        type="month"
                        placeholder="选择月份">
                        </el-date-picker>
                    </div>
					<!-- <el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker> -->
				</el-form-item>
                <el-form-item label="手机号:">
					<el-input placeholder="请输入手机号" v-model="form.tel" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="用户姓名:" style="margin-left:20px">
					<el-input placeholder="请输入用户姓名" v-model="form.name" style="width: 350px;"></el-input>
				</el-form-item>
				
				<el-form-item >
					<div style="display: flex;">
					<el-button type="primary" @click="submitForm()">查询</el-button>
					<el-button @click="resetForm()">重置</el-button>
					<download-excel style="margin-left: 13px;" class="export-excel-wrapper" :data="exceldata" :fields="json_fields"
						:header="title" type="xls" name="提现统计导出.xls">
						<el-button type="success">导出全部</el-button>
					</download-excel>
					<download-excel style="margin-left: 13px;" class="export-excel-wrapper" :data="tableData" :fields="json_fields"
						:header="title" type="xls" name="提现统计导出.xls">
						<el-button type="success">导出当前页</el-button>
					</download-excel>
					</div>
				</el-form-item>
			</el-form>
			
		</el-card>
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="month" label="支出时间" >
				</el-table-column>
				<el-table-column prop="nickname" label="平台昵称" >
				</el-table-column>
				<el-table-column prop="uid" label="平台ID" >
				</el-table-column>
				<el-table-column prop="enter_name" label="用户姓名" >
				</el-table-column>
				<el-table-column prop="tel" label="手机号">
				</el-table-column>
				<!-- <el-table-column prop="remark" label="支出属性" width="180">
					<template slot-scope="scope">
						<div v-if="scope.row.type == 1">
							余额提现
						</div>
					</template>
				</el-table-column> -->
				<el-table-column prop="total_sales" label="提现金额" >
				</el-table-column>
				<el-table-column prop="user_account.account" label="提现账户" >
				</el-table-column>
				
				<el-table-column prop="mobile" label="操作" >
					<template slot-scope="scope">
						<el-button size="mini" @click="handinfo(scope.row)">流水详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>

		<el-dialog title="详情信息" :visible.sync="dialogFormVisible" width="700px" style="height: 862px;">
			<el-table :data="userinfo" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="order_num" label="订单号" width="180">
				</el-table-column>
				<el-table-column prop="enter_name" label="用户姓名">
				</el-table-column>
				<el-table-column prop="remark" label="备注">
				</el-table-column>
				<el-table-column prop="price" label="提现金额">
				</el-table-column>
				<el-table-column prop="start_time" label="提现时间" width="180">
				</el-table-column>
			</el-table>
			<div style="height: 80px;">
				<Pageing :page="userpage" :size="usersize" :total="usertotal"
					@current-change="handleChangePageuserinfo"></Pageing>
			</div>

			<!-- <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
		  </div> -->
		</el-dialog>
	</div>
</template>

<script>
	import DownloadExcel from 'vue-json-excel'
	import Pageing from '../../components/page/page.vue'
	import {
		
        getericarechargeList,
		getrechargeuserList,
		getrechargeallList
	} from '../../api/board.js'
	export default {
		components: {
			Pageing,
			DownloadExcel
		},
		data() {
			return {
				title: '提现统计导出',
				json_fields: {
					"姓名": 'enter_name',
					/* "机构属性":'jigou', */
					"月份":"month",
					"提现总额":"total_sales",
					"手机号":"tel",
					"身份证":"user_idcard",
				},
				exceldata:[],
				formLabelWidth: '120px',
				dialogFormVisible: false,
				page: 1,
				size: 10,
				total: 0,
				tableData: [],
				runmoney: 0,
				checkAll: false,
				form: {
					tel: '',
					name: '',
					time: '',
				},
				forminfo: {},
				userinfo: {},
				userpage: 1,
				usersize: 10,
				usertotal: 0,
				userid: 807,
			};
		},
		mounted() {
			this.getuserlist()
			this.DetailsForm()
		},
		methods: {
			DetailsForm() {
				getrechargeallList().then(res => {
					this.exceldata = res
					//console.log(res);
					//return res.list.data;
				})
		},
		resetForm() {
			this.form.tel = '';
			this.form.name = '';
			this.form.time = '';
			this.getuserlist()
		},
		getuserlist() {
			getericarechargeList({
				page: this.page,
				where: this.form
			}).then(res => {
				this.runmoney = res.allmoney
				this.tableData = res.list.data
				this.total = res.list.total

			})

		},
		getmyself() {
			getrechargeuserList({
				page: this.userpage,
				uid: this.userid
			}).then(res => {
				//console.log(res);
				this.userinfo = res.data
				this.usertotal = res.total
			})
		},
		handinfo(e) {
			//console.log(e);
			this.dialogFormVisible = true
			//获取个人信息
			this.forminfo = e
			this.userid = e.uid
			this.getmyself()
		},
		submitForm() {
            this.page = 1
			this.getuserlist()
		},
		handleChangePage(val) {
			this.page = val
			this.getuserlist()
		},
		handleChangePageuserinfo(val) {
			this.userpage = val
			this.getmyself()
		}
	}
	};
</script>

<style lang="less" scoped>
	.runmoney {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
</style>
